import React from 'react';
import useSearch from '../../features/shop/hooks/useSearch';
const SearchContext = React.createContext();

export const SearchProvider = ({ children }) => {

  const {
    handleSearchAPI,
    searchResults,
    setSearchResults,
    handleSearch,
    search,
    setSearch,
    autocomplete,
    setAutocomplete,
    handleSearchCustomOptionAPI,
    setSearchResultsPagesTotal
  } = useSearch();


  return (
    <SearchContext.Provider value={{
      
      // from useSearch
      handleSearchAPI,
      searchResults,
      setSearchResults,
      handleSearch,
      search,
      setSearch,
      autocomplete,
      setAutocomplete,
      handleSearchCustomOptionAPI,
      setSearchResultsPagesTotal

    }}>
      {children}
    </SearchContext.Provider>
  )
}
export default SearchContext;